import {Batch} from 'constants/SampleConstants';
import {BioentitySummary} from 'folder-items/FileConstants';
import {EntrySummary} from 'notebook/ELNConstants';
import {SchemaFieldColumnUpdate} from 'notebook/structured-tables/StructuredTableConstants';
import {
  LookupSpecifier,
  ServerLookupAggregatedResult,
} from 'notebook/tables/lookup-field/LookupFieldDefinitionConstants';
import * as net from 'util/Net';

export interface RefreshTableDataResponse {
  bioentitySummariesById: {[bioentityId: string]: BioentitySummary};
  batchesById: {[batchId: string]: Batch};
  entrySummariesById: {[entryId: string]: EntrySummary};
  lookupFieldData: ServerLookupAggregatedResult;
  lookupFieldErrors: Array<string>;
}

export function refreshTableData(
  bioentityIds: Array<string>,
  batchIds: Array<string>,
  serverLookupQueries: Array<LookupSpecifier>
): Promise<RefreshTableDataResponse> {
  return net.postJSONPromise({
    url: '/1/api/eln:refresh-table-data',
    data: {bioentityIds, batchIds, lookupSpecifiers: serverLookupQueries},
  });
}

interface ColumnUpdatesResponse {
  columnUpdates: {
    [columnId: number]: SchemaFieldColumnUpdate | {};
  };
}

export function getColumnUpdates(entryId: string, provenanceUuid: string): Promise<ColumnUpdatesResponse> {
  return net.postJSONPromise({
    url: `/1/api/entries/${entryId}/structured-tables/${provenanceUuid}:get-column-updates`,
  });
}

export function getDataTableColumnUpdates(
  entryId: string,
  tableName: string
): Promise<ColumnUpdatesResponse> {
  return net.postJSONPromise({
    url: `/1/api/entries/${entryId}/data-tables:get-column-updates`,
    data: {tableName},
  });
}
